import * as React from "react";
import {RefObject} from "react";
import "./CardNumber.css";
import ExpirationDate from "./ExpirationDate";
import Label from "../Label";

class CreditCard extends React.Component<any, any> {
  public getPaymentToken: Function = () => {};
  private getState: Function = () => {};
  private readonly baseInput: RefObject<HTMLInputElement>;
  private readonly selectorIndex

  constructor(props: any) {
    super(props);
    this.selectorIndex = props.selectorIndex
    this.baseInput = React.createRef();
    this.state = {credit_card_number: '', credit_card_numberToken: '', card: '', cvv: '', cvvToken: '', showErrors: false};
  }

  public validate = () => {
    let state = this.getState();
    state.target = state.fields[0];
    this.onState(state);
    state.target = state.fields[1];
    this.onState(state);
  };

  private onState = (event: any) => {
    let target = event.target;
    let stateChange = {};
    stateChange[target.type] = target.error;
    stateChange[target.type + 'Token'] = target.token;
    if (target.card) stateChange['card'] = target.card;
    this.setState(stateChange);
  };

  private getStyles = () => {
    let baseStyle = window.getComputedStyle(this.baseInput.current!);

    let clonedStyle = {
      'font-size': '16px',
      'color': baseStyle.color,
      'padding': baseStyle.padding,
      'border': baseStyle.border,
      'font-family': baseStyle.fontFamily,
      'font-weight': baseStyle.fontWeight,
      'border-radius': baseStyle.borderRadius,
      'width': baseStyle.width,
      'background': baseStyle.background,
      '-webkit-font-smoothing': baseStyle.getPropertyValue('-webkit-font-smoothing'),
      '::placeholder' : { color: '#999' }
    };

    return [
      {
        selector: `#creditcard${this.props.index}`,
        input: {
          placeholder: 'Card Number',
          type: 'credit_card_number',
          css: clonedStyle
        }
      },
      {
        selector: `#cvv${this.props.index}`,
        input: {
          type: 'cvv',
          placeholder: 'CVV',
          css: clonedStyle
        }
      }
    ];
  };

  private initializeHostedFields = ()=>{
    ({
      getPaymentToken: this.getPaymentToken,
      getState: this.getState
    } = window['AffiniPay'].HostedFields.initializeFields({
      publicKey: this.props.publicKey,
      fields: this.getStyles()
    }, this.onState));
  };

  public componentDidMount() {
    this.initializeHostedFields();
  }

  public render() {
    return (
      <div>
        <div className="CardNumber">
          <Label htmlFor="creditcard" showErrors={true} error={this.state.credit_card_number}>
            Card Number
          </Label>
          <div className={`CardImage ${this.state.card} `}/>

          <input className="hidden-input" tabIndex={-1} type="text" minLength={1}
                 ref={this.baseInput}
                 onInvalid={this.validate}
                 value={this.state.credit_card_numberToken}
                 onChange={()=>{}} required/>
          <div id={`creditcard${this.props.index}`}/>
        </div>
        <ExpirationDate {...this.props} />

        <Label htmlFor="cvv" showErrors={true} error={this.state.cvv}>
          CVV
        </Label>
        <input
          onInvalid={this.validate}
          className="hidden-input" tabIndex={-1} type="text" minLength={1} value={this.state.cvvToken}
          onChange={()=>{}} required/>
        <div id={`cvv${this.props.index}`} className="HostedField"/>
      </div>
    );
  }
}

export default CreditCard;


// WEBPACK FOOTER //
// ./src/checkout/fields/creditcard/CreditCard.tsx